import type { Breakpoint, BreakpointQuery } from './responsive.types'

export const breakpoints: Record<Breakpoint, BreakpointQuery> = {
  xs: {
    min: 0,
    max: 639,
  },
  sm: {
    min: 640,
    max: 767,
  },
  md: {
    min: 768,
    max: 1023,
  },
  lg: {
    min: 1024,
    max: 1279,
  },
  xl: {
    min: 1280,
    max: 99999,
  },
}
